import React from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SmartToyIcon from "@mui/icons-material/SmartToy";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

const logoTypebot = require("./tbot.jpg");
const logoDflow = require("./dialogflow.png");
const logoGlpi = require("./glpi.png");

const integrationCards = [
  {
    title: "Dialogflow",
    description: "Chatbot Google para atendimento personalizado com intents.",
    to: "/ChatBot",
    image: logoDflow,
  },
  {
    title: "Typebot",
    description: "Fluxos conversacionais visuais para automação de atendimento.",
    to: "/Typebot",
    image: logoTypebot,
  },
  {
    title: "Assistente IA",
    description: "OpenAI, Claude ou Gemini por fila de atendimento.",
    to: "/ChatGPT",
    icon: true,
  },
  {
    title: "GLPI",
    description: "Abertura e manutenção de chamados ITSM sincronizados por fila.",
    to: "/GLPI",
    image: logoGlpi,
  },
];

const Integracoes = () => {
  return (
    <MainContainer>
      <MainHeader>
        <Title>Integrações</Title>
      </MainHeader>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Conecte chatbots, IA e sistemas de chamados ao Multi Atendimento.
        </Typography>

        <Grid container spacing={2}>
          {integrationCards.map(card => (
            <Grid item xs={12} sm={6} lg={3} key={card.title}>
              <Card variant="outlined" sx={{ height: "100%" }}>
                <CardActionArea component={RouterLink} to={card.to} sx={{ height: "100%" }}>
                  {card.icon ? (
                    <Box
                      sx={{
                        height: 140,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: theme =>
                          theme.palette.mode === "dark"
                            ? "linear-gradient(135deg, #1b2330, #2d1f1f)"
                            : "linear-gradient(135deg, #fff5f5, #ffe4e6)",
                      }}
                    >
                      <SmartToyIcon sx={{ fontSize: 72, color: "primary.main" }} />
                    </Box>
                  ) : (
                    <Box
                      component="img"
                      src={card.image}
                      alt={card.title}
                      sx={{
                        width: "100%",
                        height: 140,
                        objectFit: "scale-down",
                        p: 2,
                        bgcolor: "background.default",
                      }}
                    />
                  )}
                  <CardContent>
                    <Typography variant="h6" color="primary" gutterBottom>
                      {card.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {card.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default Integracoes;
